/**
 * Browser / IANA timezone helpers for mangosteen.
 */

export function detectBrowserTimezone(fallback = 'America/New_York'): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || fallback
  } catch {
    return fallback
  }
}

/** Minutes east of UTC (e.g. America/New_York EDT => -240). */
export function detectBrowserTimezoneOffsetMinutes(): number {
  try {
    return -new Date().getTimezoneOffset()
  } catch {
    return 0
  }
}
